import React from 'react';
import { motion } from 'framer-motion';
export function GoldDivider() {
  return <div className="flex items-center justify-center py-16 opacity-60" data-id="element-189">
      <motion.div initial={{
      width: 0,
      opacity: 0
    }} whileInView={{
      width: '100px',
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} className="h-[1px] bg-gradient-to-r from-transparent via-[#d4a843] to-transparent w-24" data-id="element-190" />
      <motion.div initial={{
      scale: 0,
      opacity: 0
    }} whileInView={{
      scale: 1,
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.5,
      duration: 0.5
    }} className="w-2 h-2 rotate-45 border border-[#d4a843] bg-[#0a1628] mx-4" data-id="element-191" />
      <motion.div initial={{
      width: 0,
      opacity: 0
    }} whileInView={{
      width: '100px',
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} className="h-[1px] bg-gradient-to-r from-transparent via-[#d4a843] to-transparent w-24" data-id="element-192" />
    </div>;
}